import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-full flex flex-col relative bg-creation-background" }
const _hoisted_2 = { class: "w-full flex-1 overflow-hidden flex justify-center items-center relative z-10" }
const _hoisted_3 = { class: "flex flex-col w-full max-h-full overflow-y-auto p-4 text-center" }
const _hoisted_4 = { class: "font-bold text-lg leading-6 text-creation-on-background" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FullHeaderComponent = _resolveComponent("FullHeaderComponent")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_FullHeaderComponent, { campaign: _ctx.campaign }, null, 8, ["campaign"]),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('creation.inactiveCampaignText')), 1)
      ])
    ]),
    _createVNode(_component_FooterComponent, { campaign: _ctx.campaign }, null, 8, ["campaign"])
  ]))
}